/*
import {useQuery} from "@tanstack/react-query";
import {readUserDataApi} from "../../../../api/support/RMA";

export const useReadUserData = () => {
    const {data} = useQuery({
        queryKey: ["readUserData"],
        queryFn: async () => await readUserDataApi(),
        select: (res) => res?.result.userVOList ?? null,
    });

    return {data};
};
* */

import {useQuery} from "@tanstack/react-query";
import { readUserDataApi } from "../../../../api/support/RMA";

type Props = {
    searchOption: any & { accountId: string };
};

export const useReadUserData = ({searchOption}: Props) => {
    const {data} = useQuery({
        queryKey: ["readUserData", searchOption],
        queryFn: async () => await readUserDataApi({...searchOption}),
        select: (res) => res?.result,
        // staleTime: 10000 * 6,
    });

    return {data};
};
